﻿import React from 'react';
import { CardRowItemContainer } from "./CardRowItemContainer";

type CardSubRowContainerProps = React.ComponentProps<typeof CardRowItemContainer>

/**
 * CardRowItemContainer styled in even more of a SecurSpace way. Used inside a SubBodyContainer to hold and style
 * subsequent item/value pairs. (see location card for what this means and lemme know if you have better naming ideas)
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CardSubRowContainer = ({ children, ...rest }: CardSubRowContainerProps) => {
  return <CardRowItemContainer md={4} {...rest}>
    { children }
  </CardRowItemContainer>
}

export { CardSubRowContainer };